// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"248":"66d0f246","697":"df724974","745":"7573b062"}[chunkId] + ".chunk.css";
};